/*global VeloxWebView*/


var extension = {} ;
extension.name = "flocculation-field" ;

//must run after fields
extension.mustRunAfter = ["fields", "country"] ;

var COUNTRY_AVAILABILITY = {
    "QUICKFLOCK_SUPER"    : { FR: true, DE: true, ES: true, GB: false},  
    "SUPERFLOCK_PLUS"     : { FR: true, DE: true, ES: true, GB: true},  
    "SUPERKLAR"           : { FR: true, DE: true, ES: true, GB: true},  
    "QUICKFLOCK_AUTO_PLUS": { FR: true, DE: true, ES: true, GB: true},  
};


function computeOptions(){
    return Object.keys(COUNTRY_AVAILABILITY).filter(function(p){
        //filter by country availability
        return COUNTRY_AVAILABILITY[p][VeloxWebView.country.get()] ;
    }).map(function(p){
        return {
            id: p,
            label: VeloxWebView.tr("fields.values.pool.p_flocculation."+p)
        } ;
    }) ;
}

extension.init = function(){
    var view = this ;
    view.on("initDone", function(){
        var flocculationEl = view.viewRootEl.querySelector('[data-field-def="pool.p_flocculation"]');
        if(flocculationEl){
            view.on("render", function(){
                flocculationEl.setOptions(computeOptions()) ;
            }) ;
        }   
    }) ;
} ;




module.exports = extension ;